import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.css']
})
export class UsuarioListComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  usuarios: any;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};
  id_usuario: any;
  level_access: any;

  constructor(
    public usuariosService: UsuariosService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
    ) { }
  
  getAll() {
    this.spinner.show();
    this.usuariosService.getAll().subscribe(data => {
      if (data != 'null') {
        const response = (data as any);
        this.usuarios = response;
        this.spinner.hide();
        // this.rerender();
        this.dtTrigger.next();
      }
    }, error => {
      this.spinner.hide();
      console.error(error);
    });
  }

  delete(id) {
    this.spinner.show();
    if (confirm("Deseja realmente deletar este registro?")) {
      this.usuariosService.delete(id).subscribe(
        data => {
          const response = (data as any);
          if (response.sucesso == true) {
            this.toastr.success('Registro excluído com sucesso!', 'Sucesso!');
            this.getAll();
          } else {
            this.toastr.error('Erro ao excluir registro!', 'Erro!');
          }
          this.spinner.hide();          
        }, error => {
          this.spinner.hide();
          console.error(error);
        }
      )
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
    });
  }

  ngOnInit() {
    this.dtOptions = {
      "language": {
        "url": "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Portuguese-Brasil.json"
      },
      "bDestroy": true
    }

    this.getAll();
  }

}
